import { Blog, brand, ResponseType, ServiceSubCategory } from '@/commonTypes';
import React from 'react';
import SearchSectionItem from './SearchSectionItem';

export default function SearchSections({
  categories,
  activeMenu,
}: {
  categories?: any;
  activeMenu?: string | number;
}) {
  const sectionsList =
    activeMenu != 'all' ? categories?.filter((x: any) => x.id == activeMenu) : categories?.slice(1);
  return (
    <>
      {sectionsList?.map((item: any, index: number) => (
        <SearchSectionItem key={index} item={item} />
      ))}
    </>
  );
}
